import { fieldIsVulcanOrder, fieldSalesRepInfo } from '../../utils/constant';
import { getFieldValue } from '../utils';
import { getLocale } from '../../misc';
import EN from '../../../EN.json';
import FR from '../../../FR.json';

const PrequalificationHelpers = ({
  isCreateOrderButtonVisible,
  formFields,
  fieldName
}) => {
  const locale = getLocale();
  const {
    vulcanWebform: { yes, no }
  } = locale === 'en-US' ? EN : FR;
  const isVulcanOrder = getFieldValue(fieldIsVulcanOrder, formFields);

  if (fieldName === fieldSalesRepInfo) {
    return true;
  }

  if (fieldName === fieldIsVulcanOrder && !isVulcanOrder) {
    isCreateOrderButtonVisible(true);
  }

  if (fieldName === fieldIsVulcanOrder && isVulcanOrder === yes) {
    isCreateOrderButtonVisible(false);
  } else if (fieldName === fieldIsVulcanOrder && isVulcanOrder === no) {
    isCreateOrderButtonVisible(true);
  }
};

export default PrequalificationHelpers;
